"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useApiUrlState = exports.DEFAULT_API_URL = exports.useModelsQuery = void 0;
const react_oauth_1 = require("@yanzi/react-oauth");
const react_query_1 = require("react-query");
const use_persisted_state_1 = __importDefault(require("use-persisted-state"));
const useModelsGroupId_1 = require("./useModelsGroupId");
function useModelsQuery(url, accountNumber) {
    const { accessToken } = react_oauth_1.useOAuth();
    const groupId = useModelsGroupId_1.useModelsGroupId(accountNumber);
    const [apiUrl] = exports.useApiUrlState(exports.DEFAULT_API_URL);
    return react_query_1.useQuery(['models', apiUrl, url, groupId], () => __awaiter(this, void 0, void 0, function* () {
        const token = yield accessToken.get();
        const res = yield fetch(`${apiUrl}/groups/${groupId}${url}`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) {
            throw new Error(`Models query failed with status code ${res.status}`);
        }
        return res.json();
    }), { staleTime: 1000 * 60 * 60 * 24, enabled: !!accessToken && !!groupId });
}
exports.useModelsQuery = useModelsQuery;
exports.DEFAULT_API_URL = 'https://models.yanzi.dev/api';
exports.useApiUrlState = use_persisted_state_1.default('models-api-url');
//# sourceMappingURL=useModelsQuery.js.map